/* SuccessContainer.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./SuccessContainer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import CheckCircleIcon from '@atlaskit/icon/core/migration/success--check-circle';
import { G300 } from '@atlaskit/theme/colors';
var sectionStyles = null;
var iconContainerStyles = null;
export default (function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("section", {
    className: ax(["_18u01jfw"])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154iv47k _1ltv1ejb"])
  }, /*#__PURE__*/React.createElement(CheckCircleIcon, {
    spacing: "spacious",
    label: "",
    "aria-hidden": true,
    color: "var(--ds-icon-success, ".concat(G300, ")"),
    LEGACY_margin: "4px 0 0 0"
  })), children);
});